import { AxiosResponse } from "axios";
import { BASE_URL, NAV_URL, httpClient } from "../config/develop-config";

const baseUrl = `${BASE_URL}/auth`;

const getCompanyList = async () => {
  return await httpClient
    .get(`${baseUrl}/company`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
export { getCompanyList };
